export default __webpack_public_path__ + "static/media/dark-car-bg.76859df8.jpg";